<template src="./BreadcrumbComponent.html"></template>
<script>
import IconHome from "@/components/icons/IconHome.vue";

export default {
  name: 'BreadcrumbComponent',
  components: {IconHome}
}
</script>
<style lang="scss">
.breadcrumb {
  margin: 0;
  .breadcrumb-item {
    font-size: 13px;
    letter-spacing: 1px;
  }
  .breadcrumb-active a {
    color: #7366ff;
    font-weight: 500;
  }
  span a:hover {
    background: #ffffff;
  }
}
</style>
